import React, { useEffect } from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import ChiSiamo from './components/ChiSiamo';
import Processo from './components/Processo';
import Contatti from './components/Contatti';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <div className="App">
      <Header />
      <Hero />
      <ChiSiamo />
      <Processo />
      <Contatti />
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;